import gql from "graphql-tag";

export default gql`
  mutation AcceptCustomerRequest(
    $id: ID!
    $companyId: ID!
    $title: String
    $description: String
  ) {
    acceptCustomerRequest(
      requestId: $id
      companyId: $companyId
      title: $title
      description: $description
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/AcceptCustomerRequest.ts